<template>
	<v-layout align-center row>
		<template v-if="!isRepost">
			<div class="text-xs-center">
				<v-avatar size="40px" class="grey lighten-3">
					<img
						v-if="!isLoading"
						:ref="`author-${authorId}`"
						:src="authorPic"
						alt="author"
					/>
				</v-avatar>
			</div>
			<v-flex class="pl-3" xs10>
				<h6 class="subheading mb-1" :class="{ 'text-ellipsis': !isFullView }">
					<b>{{ authorName }}</b>
				</h6>
				<h6 v-if="postId" class="body-1 ma-0 grey--text">
					Post id: {{ postId }} ({{ postType }})
				</h6>
				<h6 class="caption ma-0 grey--text">Author id: {{ authorId }}</h6>
			</v-flex>
		</template>

		<template v-else>
			<div class="text-xs-center">
				<v-avatar size="30px" class="grey lighten-1">
					<img
						v-if="!isLoading"
						:ref="`author-${authorId}`"
						:src="authorPic"
						alt="author"
					/>
				</v-avatar>
			</div>
			<v-flex class="pl-3 verticalCenteredChild" xs10>
				<h6
					class="subheading mb-1 black--text"
					:class="{ 'text-ellipsis': !isFullView }"
				>
					<b>{{ authorName }}</b>
				</h6>
			</v-flex>
		</template>
	</v-layout>
</template>

<script>
export default {
	name: "AnalyticsElAvatar",
	data() {
		return {
			isLoading: false
		}
	},
	props: [
		"isRepost",
		"authorPic",
		"authorName",
		"authorId",
		"postId",
		"postType",
		"isFullView"
	],
	mounted() {
		this.imageProcessing(this.authorId)
	},
	methods: {
		author(authorId) {
			return this.$refs[`author-${authorId}`]
		},
		imageProcessing(authorId) {
			const image = this.author(authorId)
			if (image) {
				this.isLoading = true
				image.onload = () => {
					this.isLoading = false
				}
				image.onerror = () => {
					this.isLoading = false
				}
			}
		}
	},
	watch: {
		authorId(newVal, oldVal) {
			if (oldVal) {
				this.$nextTick(() => {
					this.imageProcessing(newVal)
				})
			}
		}
	}
}
</script>
